import React, { useEffect, useRef, useState } from 'react'
import timeicon from '../../Assets/clock-icon.png';
import { useNavigate } from 'react-router-dom'
import './style.scss'
import emailIcon from '../../Assets/email_image.png'
import omnichannelIcon from '../../Assets/omnichannel_image.png'
import pushIcon from '../../Assets/push_image.png'
import appointmentIcon from '../../Assets/appointmentIcon.svg'
import apiIcon from '../../Assets/API.png'
import FormIcon from '../../Assets/Form.png'
import landingPageIcon from '../../Assets/landingPageIcon.png'
import { getContentData, verifyRecaptchaV2, verifyRecaptchaV3 } from '../../API/api';
import ReCAPTCHA from "react-google-recaptcha";
import Snackbar from '@mui/material/Snackbar';
import { Alert, CircularProgress, Dialog, DialogTitle, DialogContent } from '@mui/material';
function LandingPage() {
    const communicationService = ['Push Notification', 'Email Marketing']
    const [frontPageContent, setFrontPageContent] = useState([])
    const [softwareModules, setSoftwareModules] = useState([])
    const [communicationModules, setCommunicationModules] = useState([])
    const navigate = useNavigate()
    const buttonRef = useRef()
    const recaptchaRef = useRef()
    const [open, setOpen] = useState(false)
    const [errMsg, setErrMsg] = useState("")
    const [showV2, setShowV2] = useState(false)
    const getContent = async () => {
        const res = await getContentData()
        if (res.status === 200) {
            setFrontPageContent(res?.data?.data[0]?.frontPageContent)
            let services = res?.data?.data[0]?.frontPageContent?.services
            let softwareArr = []
            let communicationArr = []
            services.map((service) => {
                if (communicationService.includes(service?.title?.trim())) {
                    communicationArr.push(service)
                } else {
                    softwareArr.push(service)
                }
            })
            setSoftwareModules(softwareArr)
            setCommunicationModules(communicationArr)
        }
    }
    const getIcons = (index, type) => {

        if (type === 'software') {
            switch (index) {
                case 0: {
                    return omnichannelIcon
                }
                case 1: {
                    return FormIcon
                }
                case 2: {
                    return appointmentIcon
                }
                case 3: {
                    return apiIcon
                }
                case 4: {
                    return landingPageIcon
                }
            }
        } else {
            switch (index) {
                case 0: {
                    return emailIcon
                }
                case 1: {
                    return pushIcon
                }
            }
        }
    }

    const handleV2Change = async (token) => {
        if (!token) return;
        try {
            const v2Res = await verifyRecaptchaV2(token);
            if (v2Res.status != 200 || !v2Res?.data?.data?.success) {
                setOpen(true);
                setErrMsg("ReCAPTCHA V2 verification failed.");
                return;
            }
            setShowV2(false);
            window.parent.postMessage({ event: "request_quote", data: "requested" }, 'https://www.waymore.io');
            navigate('/quote');
        } catch (error) {
            console.error("V2 verification error:", error);
            setOpen(true);
            setErrMsg("V2 Error. Please try again.");
        }
    };

    const handleGetQuote = async () => {
        try {
            // Wait to ensure ReCAPTCHA is initialized and script is loaded
            let retryCount = 0;
            while (!window.grecaptcha && retryCount < 10) {
                await new Promise(resolve => setTimeout(resolve, 500));
                retryCount++;
            }

            if (recaptchaRef.current) {
                const token = await recaptchaRef.current.executeAsync();

                if (!token) {
                    throw new Error("ReCAPTCHA returned null token. Check site key or domain permissions.");
                }

                recaptchaRef.current.reset();
                const recaptchaRes = await verifyRecaptchaV3(token);
                if (recaptchaRes.status != 200) {
                    setOpen(true);
                    setErrMsg("ReCAPTCHA verification failed.");
                    return;
                }
                if (recaptchaRes?.data?.data?.score < 0.5) {
                    setShowV2(true);
                    return;
                }
            } else {
                throw new Error("ReCAPTCHA reference not found on page.");
            }
        } catch (error) {
            console.error("ReCAPTCHA execution error:", error);
            setOpen(true);
            setErrMsg(`ReCAPTCHA error: ${error.message || "Please try again."}`);
            return;
        }
        window.parent.postMessage({ event: "request_quote", data: "requested" }, 'https://www.waymore.io');
        navigate('/quote')
    }

    useEffect(() => {
        getContent()
    }, [])

    useEffect(() => {
        setTimeout(() => {
            if (buttonRef.current) {
                buttonRef.current.focus()
            }
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }, 1000)
    }, [])

    return (
        <div className='container' id='main-container' onClick={() => buttonRef.current.focus()}>
            <div className='header'>
                {frontPageContent?.topContent?.map((content, index) => <React.Fragment key={index}><span dangerouslySetInnerHTML={{ __html: content }}></span></React.Fragment>
                )}
                <div className='content'>
                    <span>SOFTWARE MODULES</span>
                    <div className='card-container'>
                        {softwareModules?.map((content, index) => <a key={index} className='service-container' href={content?.link} target="_blank">
                            <div className='topDiv'>
                                <span><img src={getIcons(index, 'software')}></img></span>
                                <span>{content?.title}</span>
                            </div>
                            <span className='bottom-content'>{content?.content}</span>

                        </a>
                        )}
                    </div>
                    <span>COMMUNICATION CHANNELS</span>
                    <div className='card-container-com'>
                        {communicationModules?.map((content, index) => <a key={index} className='service-container' href={content?.link} target="_blank">
                            <div className='topDiv'>
                                <span><img src={getIcons(index, 'communication')}></img></span>
                                <span>{content?.title}</span>
                            </div>
                            <span className='bottom-content'>{content?.content}</span>

                        </a>
                        )}
                    </div>
                </div>
            </div>
            <div className='end-content'>{frontPageContent?.endContent}</div>
            <div className='footer'>
                <div className="time"><img src={timeicon} />{frontPageContent?.footer?.time?.text}</div>
                <div><button ref={buttonRef} className='get-quote' id='get-quote' onClick={handleGetQuote}>{frontPageContent?.footer?.button?.text}</button> <span>{frontPageContent?.footer?.enterText}</span></div>
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY_V3}
                    size="invisible"
                    ref={recaptchaRef}
                />
            </div>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={() => { setOpen(false); setErrMsg("") }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={() => { setOpen(false); setErrMsg("") }} severity="error">
                    {errMsg}
                </Alert>
            </Snackbar>
            <Dialog open={showV2} onClose={() => setShowV2(false)}>
                <DialogTitle>Please verify you are a human</DialogTitle>
                <DialogContent style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                    <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY_V2}
                        onChange={handleV2Change}
                    />
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default LandingPage